module.exports = __webpack_public_path__ + "static/sexologa-text-2-ab1583bebbadf073d92e847a5f295f1c.svg";